/**
 * Re-export from @shared/auth (portal + services share sessionStorage cache key)
 */
export {
  getCachedPortalLogo,
  setCachedPortalLogo,
  clearCachedPortalLogo,
  fetchTenantPortalLogo,
} from '@shared/auth';

import { fetchTenantPortalLogo, getCachedPortalLogo, setCachedPortalLogo } from '@shared/auth';
import { getTenantAuthStorage } from '@/utils/authStorage';

export async function prefetchTenantPortalLogo(tenantId: string): Promise<void> {
  const token = getTenantAuthStorage().getToken();
  if (!token) return;
  if (getCachedPortalLogo(tenantId)) return;
  try {
    const logo = await fetchTenantPortalLogo(tenantId, token, '');
    if (logo) setCachedPortalLogo(tenantId, logo);
  } catch {
    // non-blocking
  }
}
